import _regeneratorRuntime from '@babel/runtime-corejs3/helpers/regeneratorRuntime';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState, useRef, useEffect } from 'react';
import Lottie from 'react-lottie-player';
import { c as classNames } from '../../shared/bind-97fc4987.js';
import { getTestId } from '../../utils/testId.js';
import { MediaSize } from '../types.js';
import { jsx } from 'react/jsx-runtime';
import { ImageWithForwardedRef } from '../Image/Image.js';

var styles = {
  "unit-base": "4",
  "animation": "web_ui__Animation__animation",
  "x-small": "web_ui__Animation__x-small",
  "small": "web_ui__Animation__small",
  "regular": "web_ui__Animation__regular",
  "medium": "web_ui__Animation__medium",
  "large": "web_ui__Animation__large",
  "x-large": "web_ui__Animation__x-large",
  "x2-large": "web_ui__Animation__x2-large",
  "x3-large": "web_ui__Animation__x3-large",
  "x4-large": "web_ui__Animation__x4-large",
  "content": "web_ui__Animation__content"
};

var cssClasses = classNames.bind(styles);
var Animation = function Animation(_ref) {
  var size = _ref.size,
    fallbackImageSrc = _ref.fallbackImageSrc,
    fallbackImageScale = _ref.fallbackImageScale,
    alt = _ref.alt,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'presentation' : _ref$role,
    aria = _ref.aria,
    testId = _ref.testId,
    _ref$play = _ref.play,
    play = _ref$play === void 0 ? true : _ref$play,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    animationUrl = _ref.animationUrl,
    initialAnimationData = _ref.animationData;
  var _useState = useState(initialAnimationData || null),
    _useState2 = _slicedToArray(_useState, 2),
    animationData = _useState2[0],
    setAnimationData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loadError = _useState4[0],
    setLoadError = _useState4[1];
  var isComponentMounted = useRef(true);
  useEffect(function () {
    return function () {
      isComponentMounted.current = false;
    };
  }, []);
  useEffect(function () {
    var fetchAnimation = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (animationUrl) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", null);
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return fetch(animationUrl);
            case 5:
              response = _context.sent;
              if (response.ok) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", null);
            case 8:
              _context.next = 10;
              return response.json();
            case 10:
              return _context.abrupt("return", _context.sent);
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              return _context.abrupt("return", null);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 13]]);
      }));
      return function fetchAnimation() {
        return _ref2.apply(this, arguments);
      };
    }();
    var loadAnimationFromUrl = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var animationFromUrl;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchAnimation();
            case 2:
              animationFromUrl = _context2.sent;
              if (isComponentMounted.current) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              if (animationFromUrl) {
                setAnimationData(animationFromUrl);
              } else {
                setLoadError(true);
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function loadAnimationFromUrl() {
        return _ref3.apply(this, arguments);
      };
    }();
    if (initialAnimationData) {
      setAnimationData(initialAnimationData);
    } else if (animationUrl) {
      loadAnimationFromUrl();
    }
  }, [initialAnimationData, animationUrl]);
  var className = cssClasses('animation', size);
  return /*#__PURE__*/jsx("div", {
    className: className,
    "data-testid": testId,
    children: loadError || !animationData ? /*#__PURE__*/jsx(ImageWithForwardedRef, {
      src: fallbackImageSrc,
      alt: alt || '',
      size: size,
      scaling: fallbackImageScale,
      testId: getTestId(testId, 'fallback-image')
    }) : /*#__PURE__*/jsx(Lottie, {
      className: cssClasses('content'),
      title: alt,
      role: role,
      play: play,
      loop: loop,
      "aria-label": aria === null || aria === void 0 ? void 0 : aria['aria-label'],
      animationData: animationData,
      "data-testid": getTestId(testId, 'animation')
    })
  });
};
Animation.Size = MediaSize;
Animation.ImageScaling = ImageWithForwardedRef.Scaling;

export { Animation as default };
//# sourceMappingURL=Animation.js.map
